import BlankState from './blank-state'
import TurboContainer from './turbo-container'
import Loading from './loading'
import Head from './head'

const prefix = 'bsco-'

// add elements here to initialize
const elements = {
  [`${prefix}blank-state`]: BlankState,
  [`${prefix}loading`]: Loading,
  [`${prefix}head`]: Head,
  'turbo-container': TurboContainer
}

for (const key in elements) {
  if (!window.customElements.get(key)) {
    window.customElements.define(key, elements[key])
  }
}
